import React from 'react';
import { HeroB2B } from '../sections/b2b/HeroB2B';
import { BenefitsB2B } from '../sections/b2b/BenefitsB2B';
import { HowItWorksB2B } from '../sections/b2b/HowItWorksB2B';
import { ContactB2B } from '../sections/b2b/ContactB2B';
export default function B2B() {
  return <>
      <HeroB2B data-id="element-66" />
      <BenefitsB2B data-id="element-67" />
      <HowItWorksB2B data-id="element-68" />
      <ContactB2B data-id="element-69" />
    </>;
}